import { useEffect, useState } from 'react';
import { Engagement } from 'src/editor/insights/constants';
import { useDepsMatchingCallbackRef } from 'src/utils/react/deps-matching-callback-ref.hook';
import { apiGetJourneyEngagements } from 'src/utils/journeyApi';
import { TimePeriodParam } from '../constants';

type Params = {
  journeyId?: number;
  filters?: {
    session_uuid?: string;
    time_period?: TimePeriodParam;
  };
};

export const useEngagementsMetrics = ({ journeyId, filters }: Params) => {
  const [fetching, setFetching] = useState(true);
  const [engagements, setEngagements] = useState<Engagement[]>([]);

  const onFetchJourneyInsightsRef = useDepsMatchingCallbackRef(
    (response: any) => {
      setEngagements(response.all_time as Engagement[]);
      setFetching(false);
    },
    [journeyId, filters]
  );

  useEffect(() => {
    const fetchEngagements = async () => {
      setFetching(true);
      if (journeyId) {
        // @ts-ignore
        const response = await apiGetJourneyEngagements(
          // @ts-ignore
          journeyId,
          true,
          filters?.session_uuid || undefined,
          filters?.time_period || undefined
        );
        onFetchJourneyInsightsRef.current && onFetchJourneyInsightsRef.current(response, [journeyId, filters]);
      }
    };
    fetchEngagements();
  }, [journeyId, filters]);
  return { fetching, engagements };
};
